import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '首页', to: '/' },
        { label: '电影', to: '/category/movie' },
        { label: '电视剧', to: '/category/tv' },
        { label: '综艺', to: '/category/variety' },
        { label: '动漫', to: '/category/anime' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '信誉保障', to: '/about' },
        { label: '联系我们', to: '/about' },
      ],
    },
    {
      title: '帮助支持',
      links: [
        { label: '常见问题', to: '/#faq' },
        { label: '使用帮助', to: '/about' },
        { label: '意见反馈', to: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                红桃视频
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              红桃视频在线观看 — 免费高清视频播放平台，每日更新，即点即播。海量视频资源，支持多端畅看。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-background-700 flex items-center justify-center text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-700 flex items-center justify-center text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-700 flex items-center justify-center text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 红桃视频在线观看 版权所有 | 红桃视频在线观看,红桃视频免费观看,红桃视频高清播放
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors">服务条款</a>
            <a href="#" className="hover:text-background-50 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}